module.exports = __webpack_public_path__ + "img/叶坪公略亭.68fc603a.png";